// interface Properties {
//   width?: number;
//   height?: number;
// }

const UserBorderNew = () => {
  return (
    <svg width='66' height='66' viewBox='0 0 66 66' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='66' height='66' rx='33' fill='#E0DAFE' />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M44.6663 28.7707C44.6663 27.7987 44.2797 26.8667 43.593 26.1787C42.309 24.896 39.7703 22.3573 38.4877 21.0733C37.7997 20.3867 36.8677 20 35.8957 20C34.1557 20 30.669 20 27.6663 20C25.9863 20 24.3757 20.6667 23.1877 21.8547C21.9997 23.0427 21.333 24.6533 21.333 26.3333V39.6667C21.333 43.164 24.169 46 27.6663 46H38.333C41.8303 46 44.6663 43.164 44.6663 39.6667C44.6663 35.8147 44.6663 30.9253 44.6663 28.7707ZM35.9997 22.0027C35.965 22.0013 35.9303 22 35.8957 22C34.1557 22 30.669 22 27.6663 22C26.517 22 25.4143 22.456 24.6023 23.2693C23.789 24.0813 23.333 25.184 23.333 26.3333V39.6667C23.333 42.06 25.273 44 27.6663 44H38.333C40.7263 44 42.6663 42.06 42.6663 39.6667C42.6663 35.8147 42.6663 30.9253 42.6663 28.7707C42.6663 28.736 42.665 28.7013 42.6637 28.6667H39.6663C38.6943 28.6667 37.761 28.28 37.073 27.5933C36.3863 26.9053 35.9997 25.972 35.9997 25V22.0027ZM41.2517 26.6667L37.9997 23.4147V25C37.9997 25.4427 38.1757 25.8653 38.4877 26.1787C38.801 26.4907 39.2237 26.6667 39.6663 26.6667H41.2517Z'
        fill='#6B5FC6'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M32.9993 29.3333H33.0233C33.1153 29.336 33.2047 29.3506 33.2887 29.376L33.2913 29.3773C33.4433 29.4226 33.586 29.5066 33.706 29.6266L36.3727 32.2933C36.7633 32.6826 36.7633 33.3173 36.3727 33.7066C35.9833 34.0973 35.3487 34.0973 34.9593 33.7066L33.9993 32.748V37C33.9993 37.552 33.5513 38 32.9993 38C32.4473 38 31.9993 37.552 31.9993 37V32.748L31.0393 33.7066C30.65 34.0973 30.0153 34.0973 29.626 33.7066C29.2353 33.3173 29.2353 32.6826 29.626 32.2933L32.2927 29.6266C32.4127 29.5066 32.5553 29.4226 32.7073 29.3773L32.71 29.376C32.794 29.3506 32.8833 29.336 32.9753 29.3333H32.9993Z'
        fill='#6B5FC6'
      />
    </svg>
  );
};

export default UserBorderNew;
